import getCanvasBounds from './getCanvasBounds';
import getPanAndZoom from './getPanAndZoom';

export default function getCanvasPanZoomBounds() {
    const { x, y, zoom } = getPanAndZoom();
    return { bounds: { ...getCanvasBounds() }, pan: { x, y }, zoom };
}
